import { combineReducers } from '@reduxjs/toolkit'
import sidebar from './sidebar.store'

export const rootReducer = combineReducers({
  sidebar,
})
